var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12 3 C 8.14 3 5 6.141 5 10 C 5 12.410337 6.2256309 14.541088 8.0859375 15.800781 C 4.5135649 17.328535 2 20.878337 2 25 L 4 25 C 4 20.59 7.59 17 12 17 C 13.44 17 14.790937 17.380547 15.960938 18.060547 C 16.370938 17.510547 16.829844 17.000781 17.339844 16.550781 C 16.886742 16.262444 16.400847 16.021871 15.900391 15.808594 C 17.767985 14.550033 19 12.415944 19 10 C 19 6.141 15.86 3 12 3 z M 12 5 C 14.757 5 17 7.243 17 10 C 17 12.757 14.757 15 12 15 C 9.243 15 7 12.757 7 10 C 7 7.243 9.243 5 12 5 z M 24 16 C 19.6 16 16 19.6 16 24 C 16 28.4 19.6 32 24 32 C 28.4 32 32 28.4 32 24 C 32 19.6 28.4 16 24 16 z M 24 18 C 27.3 18 30 20.7 30 24 C 30 27.3 27.3 30 24 30 C 20.7 30 18 27.3 18 24 C 18 20.7 20.7 18 24 18 z M 27 21.300781 L 23.699219 24.599609 L 21.400391 22.300781 L 20 23.699219 L 23.699219 27.400391 L 28.400391 22.699219 L 27 21.300781 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.1da323b1d3e9f2258a9d7820ac87839b.svg";
export { ForwardRef as ReactComponent };